import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AllScouts.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';

const AllScouts = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const {slug} = useParams();

    const [activeScouts, setActiveScouts] = useState([]);

    useEffect(() => {
        const staticData = [
            {   
                id: "1", 
                name: 'Matthew Judd',
                // image: '/images/Test_grid_1000x1000.png',
                city:'Toronto',
                state: 'Alabama',
                country:'US',
                url:'',
                // continent:{value:'4', label:'Asia'},
                sport: 'Baseball',
            },
            {   
                id: "2", 
                name: 'Ambia Mari Abolucion',
                // image: '/images/Test_grid_1000x1000.png',
                city:'Chelsea',
                state: 'Alabama',
                country:'US',
                url:'',
                // continent:{value:'7', label:'North America'},
                sport: 'Basketball',
            },
            {   
                id: "3", 
                name: 'Ashok Anjara',
                // image: '/images/Test_grid_1000x1000.png',
                city:'Phoenix',
                state: 'Arizona',
                country:'US',
                url:'',
                // continent:{value:'4', label:'Asia'},
                sport: 'Football',
            },
            {   
                id: "4", 
                name: 'Ashok Anjara',
                image: '',
                city:'',
                state: 'California',
                country:'US',
                url:'',
                // continent:{value:'4', label:'Asia'},
                sport: 'Football (American)',
            }
        ];
        //setActiveScouts(staticData);
    },[]);

        //pagination
        const [currentPage, setCurrentPage] = useState(1);
        const [itemsPerPage, setItemsPerPage] = useState(50);
    
            const startIndex =
                (currentPage - 1) * itemsPerPage;
            const endIndex =
                startIndex + itemsPerPage;
            const currentItems =
                activeScouts.slice(startIndex, endIndex);
    
        function goToNextPage() {
            setCurrentPage(prevPage => prevPage + 1);
        }
    
        function goToPrevPage() {
            setCurrentPage(prevPage => prevPage - 1);
        }
    
        function goToSpecificPage(pageNumber) {
            setCurrentPage(pageNumber);
        }
        function renderPaginationControls() {
            const totalPages = Math.ceil(activeScouts.length / itemsPerPage);

            const goToFirstPage = () => setCurrentPage(1);
            const goToLastPage = () => setCurrentPage(totalPages);

            const maxButtons = 10;
            let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
            let endPage = startPage + maxButtons - 1;

            if (endPage > totalPages) {
                endPage = totalPages;
                startPage = Math.max(1, endPage - maxButtons + 1);
            }

            const pageNumbers = [];
            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }

            return (
                <div>
                    {activeScouts.length > itemsPerPage && (
                        <div style={{ textAlign: "center" }} className="all-scout-list-pagination">

                            {/* First + Prev */}
                            {currentPage !== 1 && (
                                <>
                                    <button onClick={goToFirstPage}>« First</button>
                                    <button onClick={goToPrevPage}>‹ Previous</button>
                                </>
                            )}
                            {pageNumbers.map((num) => (
                                <button
                                    key={num}
                                    onClick={() => goToSpecificPage(num)}
                                    style={{
                                        fontWeight: num === currentPage ? "bold" : "normal",
                                        color: num === currentPage ? "#111" : "#2c99d2",
                                    }}
                                >
                                    {num}
                                </button>
                            ))}

                            {/* Next + Last */}
                            {currentPage !== totalPages && (
                                <>
                                    <button onClick={goToNextPage}>Next ›</button>
                                    <button onClick={goToLastPage}>Last »</button>
                                </>
                            )}
                        </div>
                    )}
                </div>
            );
        }
        const lastPageIndex = Math.min(activeScouts.length, endIndex);

    React.useEffect(() => {
         const fetchData = async () => {
            // Simulate API call to your server
            // In a real application, replace this with your actual fetch logic
            try {
               setIsLoading(true);
            const response = await fetch(app_url+'', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
               page: currentPage,
            pagesize: itemsPerPage,
            // id:continentid
              }),
            });
            const data = await response.json();
            setActiveScouts(data.data.result);
          }  catch (error) {
                  console.error('Error fetching data:', error);
                } finally {
                  setIsLoading(false); // Set loading to false after fetch completes (success or error)
                }
          };
      
          fetchData();
         
        }, [currentPage]); // Re-fetch data when these change

    return (
        <>      
        {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main">
                <Helmet><title>All Scouts</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <div className="all-scout-container">
                        <div>
                            <h1>Scouts</h1>
                            <div className="view-header">
                                Displaying {activeScouts ? (startIndex+1) : (0)} - {activeScouts ? (lastPageIndex) : (0)} of {activeScouts ? (activeScouts.length) : (0)}
                            </div>
                            <div className="all-scout-list-container">
                                <ul>
                                    {currentItems.map((scout, index) => (
                                    <li key={index}>  
                                        <div className="">
                                            <a href={scout.url}  target="_blank" rel="noreferrer">
                                                {((scout.image === '') || !scout.image )? (
                                                    <img
                                                        src='/basic/web/images/notavailable.jpg'
                                                        alt={scout.name}
                                                        style={{maxWidth: "100px", maxHeight: "100px"}}
                                                    />
                                                ) : (
                                                    <img
                                                        src={scout.image}
                                                        alt={scout.name}
                                                        style={{maxWidth: "100px", maxHeight: "100px"}}
                                                    />
                                                )}
                                            </a>
                                        </div> 

                                        <div className="">
                                            <a href={scout.url}  target="_blank" rel="noreferrer">{scout.name}</a>
                                        </div>
                                        <div className="">
                                            <div className="">{scout.sport} Scout</div>  
                                        </div>
                                        <div className="">
                                            <div className="">{scout.state}</div>
                                        </div>
                                        <div className="">
                                            <div className="">{scout.country}</div>
                                        </div>
                                    </li>
                                    ))}
                                </ul>
                            </div>
                            <div style={{clear: "both"}}></div>
                            {renderPaginationControls()}
                        </div>
                    </div>
                </div>
                <div className="right"></div>
            </div>
        )}
        </>
    );
};
export default AllScouts;